var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgetSeparatorBlue = function SvgWidgetSeparatorBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M4 12h16"
  })));
};
export { SvgWidgetSeparatorBlue as ReactComponent };
export default __webpack_public_path__ + "8eeb6ac3eca54dc6dd2ce24b0af0cc6f.svg";